import React from "react";
import BilingualInput from "./BilingualInput";
import BilingualTextArea from "./BilingualTextArea";

type ClientsEditorFieldsProps = {
  data?: any;
  updateField: (key: string, value: string) => void;
  listKey?: string;
  defaultTitle?: string;
  defaultDescription?: string;
};

const ClientsEditorFields: React.FC<ClientsEditorFieldsProps> = ({
  data,
  updateField,
  listKey = "clients_list",
  defaultTitle = "Our Clients",
  defaultDescription = "Trusted clients across Hamdan Group divisions and operations in Oman.",
}) => (
  <div className="space-y-6">
    <div className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 text-xs font-bold leading-relaxed text-amber-800">
      Add one client per line. For card details, use:
      <br />
      Client Name | Sector / Service | Location
      <br />
      Logo URLs can be one per line, or Client Name | Logo URL.
    </div>

    <BilingualInput
      label="Clients Title"
      englishValue={data?.clients_title ?? defaultTitle}
      arabicValue={data?.clients_title_ar}
      onChangeEnglish={(value) => updateField("clients_title", value)}
      onChangeArabic={(value) => updateField("clients_title_ar", value)}
    />

    <BilingualTextArea
      label="Clients Description"
      englishValue={data?.clients_desc ?? defaultDescription}
      arabicValue={data?.clients_desc_ar}
      onChangeEnglish={(value) => updateField("clients_desc", value)}
      onChangeArabic={(value) => updateField("clients_desc_ar", value)}
    />

    <BilingualTextArea
      label="Clients List"
      englishValue={data?.[listKey] ?? ""}
      arabicValue={data?.[`${listKey}_ar`]}
      onChangeEnglish={(value) => updateField(listKey, value)}
      onChangeArabic={(value) => updateField(`${listKey}_ar`, value)}
    />

    <BilingualTextArea
      label="Client Logo URLs"
      englishValue={data?.clients_logo_urls ?? ""}
      arabicValue=""
      onChangeEnglish={(value) => updateField("clients_logo_urls", value)}
      onChangeArabic={() => undefined}
      placeholder="https://example.com/client-logo.png"
      rows={4}
    />

    <BilingualInput
      label="Clients Footer"
      englishValue={data?.clients_footer ?? ""}
      arabicValue={data?.clients_footer_ar}
      onChangeEnglish={(value) => updateField("clients_footer", value)}
      onChangeArabic={(value) => updateField("clients_footer_ar", value)}
    />

    <BilingualTextArea
      label="Clients Footer Description"
      englishValue={data?.clients_footer_desc ?? ""}
      arabicValue={data?.clients_footer_desc_ar}
      onChangeEnglish={(value) => updateField("clients_footer_desc", value)}
      onChangeArabic={(value) => updateField("clients_footer_desc_ar", value)}
    />
  </div>
);

export default ClientsEditorFields;
